import { Auth } from "aws-amplify"
import moment from "moment"
import React, { Component } from "react"
import { connect } from "react-redux"
import NewPartyModal from "../../party/NewPartyModal/NewPartyModal"
import SiteWrapper from "../../structure/SiteWrapper/SiteWrapper"
import * as styles from "./PartyListModal.module.scss"
import lambdas from "@data/lambdas"
import * as actions from "@store/actions"
import ReactModal from "@components/global/ReactModal/ReactModal"
import SimpleIntro from "@components/layouts/global/SimpleIntro/SimpleIntro"
import partyIcon from "@images/icons/partyIcon.svg"
import pencilDark from "@images/icons/pencilDark.svg"

const { PARTY_GET, SUPPLIER_SEARCH } = lambdas[process.env.NEXT_PUBLIC_ENV]

class PartyListModal extends Component {
  state = {
    modalIsOpen: false,
    parties: [],
  }

  setUpParty = async (party) => {
    const { categoryOptions, countyOptions } = this.props.staticData

    let partyLocationData = ""
    let savedSuppliers = []

    let location = null
    if (party.partyLocation) {
      const locationObject = JSON.parse(party.partyLocation)
      if (locationObject.countyId) {
        const locationFilterObject = countyOptions.find((findValue) => findValue.value === locationObject.countyId)
        partyLocationData = locationFilterObject
        location = { query: locationFilterObject.label }
      } else {
        partyLocationData = { ...locationObject, label: locationObject.query }
        location = locationObject
      }
    }

    //setup options data in state
    const partyCategoryData = categoryOptions.find((category) => category.value === party.partyCategory)

    const partyDate = moment(Number(party.partyDate))

    if (party.savedSuppliers && party.savedSuppliers.length) {
      savedSuppliers = await this.getSavedSuppliers(party.savedSuppliers)
    }

    const newPartyData = {
      ...party,
      savedSuppliers,
      partyDate,
      partyCategoryData,
      partyLocationData,
      location,
    }

    this.props.partyUpdate(newPartyData)
  }

  getSavedSuppliers = async (savedSuppliers) => {
    try {
      const response = await fetch(SUPPLIER_SEARCH, {
        method: "POST",
        body: JSON.stringify({
          params: {
            ids: savedSuppliers.map((savedSupplier) => savedSupplier.id),
          },
        }),
      })
      if (response.ok) {
        const data = await response.json()
        const suppliers = data.result.allSuppliers.map((supplier) => {
          const savedSupplier = savedSuppliers.find((el) => el.id === supplier.id)
          return {
            id: supplier.id,
            slug: supplier.slug,
            name: supplier.name,
            coverphoto: supplier.coverphoto,
            description: supplier.description,
            supplierservices: supplier.supplierservices,
            pricerange: supplier.pricerange,
            supplierNote: savedSupplier.supplierNote,
            supplierStatus: savedSupplier.supplierStatus,
          }
        })
        return suppliers
      } else {
        alert(
          "There has been an error, please refresh the page and try again. If it persists please contact us at supplier@houseofpartyplanning.com"
        )
        return false
      }
    } catch (err) {
      console.log(err)
      alert(
        "There has been an error, please refresh the page and try again. If it persists please contact us at supplier@houseofpartyplanning.com"
      )
      return false
    }
  }

  openModal = () => {
    this.setState({ modalIsOpen: true })
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  componentDidMount = async () => {
    try {
      const user = await Auth.currentSession()

      const response = await fetch(PARTY_GET, {
        method: "POST",
        body: JSON.stringify({
          sessionToken: user.getIdToken().getJwtToken(),
        }),
      })

      if (response.ok) {
        const data = await response.json()

        this.setState({ parties: data.data.Items })
      } else {
        alert(
          "There has been an error, please refresh the page and try again. If it persists please contact us at supplier@houseofpartyplanning.com"
        )
      }
    } catch (err) {
      console.log(err)
      alert(
        "There has been an error, please refresh the page and try again. If it persists please contact us at supplier@houseofpartyplanning.com"
      )
    }
  }

  handleSumbit = async (event, party) => {
    event.preventDefault()

    try {
      this.setUpParty(party)
      this.setState({ modalIsOpen: false })
    } catch (err) {
      console.log(err)
      alert(
        "There has been an error, please refresh the page and try again. If it persists please contact us at supplier@houseofpartyplanning.com"
      )
    }
  }

  render() {
    return (
      <div>
        <ReactModal
          button={this.props.button}
          modalLabel="Party List"
          onRequestClose={this.closeModal}
          modalIsOpen={this.state.modalIsOpen}
          openModal={this.openModal}
        >
          <section className={styles.PartyListModal}>
            <SimpleIntro
              icon={partyIcon}
              title="Current party"
              description="By selecting a current party, suppliers will automatically be saved to it"
            />
            <SiteWrapper className={styles.full}>
              {/* return ; */}

              <div>
                <form>
                  {this.state.parties && this.state.parties.length
                    ? this.state.parties.map((party, index) => (
                        <div key={party.partyId}>
                          <input
                            type="radio"
                            id={party.partyId}
                            name={party.partyId}
                            value={party.partyName}
                            checked={party.partyId === this.props.currentParty.partyId}
                          />
                          <label onClick={(e) => this.handleSumbit(e, party)} htmlFor={party.partyId}>
                            {party.partyName}
                          </label>
                        </div>
                      ))
                    : null}
                </form>
              </div>
            </SiteWrapper>
            <SiteWrapper>
              <div className={styles.buttons}>
                <NewPartyModal
                  button={{
                    text: "New Party",
                    image: pencilDark,
                    design: "outline",
                    color: "dark",
                  }}
                />
              </div>
            </SiteWrapper>
          </section>
        </ReactModal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentParty: state.party.currentParty,
    staticData: state.staticData.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    partyUpdate: (party) => dispatch(actions.partyUpdate(party)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PartyListModal)
